import { css } from "@emotion/css";
import { INPUT_MARKER_OFFSET, TRACKER_CLIP_PADDING } from "./agenda.constants";

// Clips the ProgressTracker's own overflow (its internal flex sizing spills past its box). The
// vertical padding keeps the edit/add row's negative margins (INPUT_MARKER_OFFSET) from being
// clipped on the first and last rows.
export const trackerClipClass = css({
  overflow: "hidden",
  paddingTop: TRACKER_CLIP_PADDING,
  paddingBottom: TRACKER_CLIP_PADDING,
});

// Lets an inline edit/add input extend above and below its layout slot so the tracker marker stays
// centered on it without the taller input growing the row. The per-step gap spacer absorbs the
// extra height, so nothing below shifts.
export const editRowOffsetClass = css({
  width: "100%",
  marginTop: -INPUT_MARKER_OFFSET,
  marginBottom: -INPUT_MARKER_OFFSET,
});

// Row title: allow a long title to shrink below its intrinsic width inside the narrow panel
// (minWidth 0) and to break mid-word rather than overflow (overflowWrap). Applied to every
// TitleContent branch so wrapping behaviour is identical across row states.
export const rowTitleClass = css({ minWidth: 0, overflowWrap: "anywhere" });

// Strikethrough via class (not <s>) to keep text aligned with the tracker marker.
export const strikethroughClass = css({ textDecorationLine: "line-through" });

// Hides the connector into the unsaved add step (transparent, not display:none, to avoid shifts).
export const hideAddConnectorClass = css({
  "& li:nth-last-child(2) [mdn-progress-tracker-complete], & li:nth-last-child(2) [mdn-progress-tracker-incomplete]": {
    backgroundColor: "transparent !important",
  },
});

// Hides the add step's marker while the row is showing its "+ Add agenda" trigger (the trigger has
// its own icon and no marker in the design). visibility (not display) so the marker keeps its space
// and the row doesn't shift when the marker appears on open. The `>` matters: Meridian's Icon also
// renders role="img", so a descendant selector would hide the trigger's own "+" icon as well.
export const hideAddMarkerClass = css({
  '& li:last-child > [role="img"]': {
    visibility: "hidden",
  },
});